export function downloadTableScroll() {
  const maxTableWidth = 1255;
  const tableHeader = $('.table-header');
  const tableHeaderSpacer = $('.table-header-spacer');
  const downloadTableGrid = $('.grid');
  const pathname = window.location.pathname;

  if (pathname.includes("all-product-downloads")) {
    let stickyOffsetHeight = tableHeader.offset().top;

    //handle header dynamic x-scroll
    downloadTableGrid.on('scroll', (event) => {
      tableHeader.css({
        left: -downloadTableGrid.scrollLeft() + 'px'
      });
    });

    //handle sticky behavior during scrolling/resizing
    $(window).on('resize', (event) => {

      if ($(window).width() < maxTableWidth) {
        tableHeader.css({
          left: -downloadTableGrid.scrollLeft() + 'px'
        });
      } else {
        tableHeader.css({
          left: 'auto'
        });
      }

      /* 
      this if-case prevents `offset().top = window.scrollTop()` behavior on resize 
      perhaps this is due to a gap between two media query breakpoints? ¯\_(0_o)_/¯
      https://github.com/mobyinc/LightArt-Website/pull/105#discussion_r797814805  
      */
      if (Math.abs(tableHeader.offset().top - stickyOffsetHeight < 100)) {
        stickyOffsetHeight = tableHeader.offset().top;
      }
    });

    $(window).on('scroll', (event) => {
      if ($(window).scrollTop() > stickyOffsetHeight) {
        tableHeader.addClass('sticky');
        tableHeaderSpacer.css({ display: 'block' });

        if ($(window).width() < maxTableWidth) {
          tableHeader.css({
            left: -downloadTableGrid.scrollLeft() + 'px'
          });
        }

      } else {
        tableHeader.removeClass('sticky');
        tableHeader.css({ left: 'auto' });
        tableHeaderSpacer.css({ display: 'none' });
      }
    });
  }
}
